import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { partyApi } from '../lib/api'

export default function PartyCreatePage() {
  const navigate = useNavigate()
  const [name, setName] = useState('')
  const [maxParticipants, setMaxParticipants] = useState(10)
  const [submitting, setSubmitting] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setSubmitting(true)
    setError(null)

    try {
      const party = await partyApi.create({
        name: name.trim(),
        max_participants: maxParticipants,
      })
      navigate(`/parties/${party.id}`)
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to create party')
      setSubmitting(false)
    }
  }

  return (
    <div className="max-w-lg mx-auto">
      <h1 className="text-2xl font-bold text-gray-900 mb-6">Create Party</h1>

      <form onSubmit={handleSubmit} className="bg-white shadow rounded-lg p-6 space-y-5">
        {error && (
          <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-md text-sm">
            {error}
          </div>
        )}

        <div>
          <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">
            Party Name
          </label>
          <input
            id="name"
            type="text"
            required
            maxLength={100}
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="block w-full rounded-md border-gray-300 shadow-sm focus:border-brand-500 focus:ring-brand-500 sm:text-sm"
            placeholder="e.g. U12 Championship Final"
          />
        </div>

        <div>
          <label htmlFor="maxParticipants" className="block text-sm font-medium text-gray-700 mb-1">
            Max Participants
          </label>
          <input
            id="maxParticipants"
            type="number"
            min={2}
            max={20}
            value={maxParticipants}
            onChange={(e) => setMaxParticipants(Number(e.target.value))}
            className="block w-full rounded-md border-gray-300 shadow-sm focus:border-brand-500 focus:ring-brand-500 sm:text-sm"
          />
          <p className="mt-1 text-xs text-gray-500">Between 2 and 20 camera participants</p>
        </div>

        <button
          type="submit"
          disabled={submitting || !name.trim()}
          className="w-full inline-flex justify-center items-center px-4 py-2 bg-brand-600 text-white text-sm font-medium rounded-md hover:bg-brand-700 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {submitting ? 'Creating...' : 'Create Party'}
        </button>
      </form>
    </div>
  )
}
